import { ADMIN_PREFIX_PATH } from '../AppConfig'
import {
  PieChartOutlined,
  LineChartOutlined,
  ApartmentOutlined,
  DatabaseOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  MoneyCollectOutlined,
  ContainerOutlined,
  TeamOutlined,
  LikeOutlined,
  HistoryOutlined,
  SettingOutlined,
  BankOutlined,
  ScheduleOutlined,
  ShopOutlined,
  MessageOutlined,
  CloseCircleOutlined,
  CreditCardOutlined,
} from '@ant-design/icons'

let navTree

if (process.env.REACT_APP_ENVIRONMET !== 'development') {
  navTree = [
    {
      key: 'Home',
      path: `${ADMIN_PREFIX_PATH}/Home`,
      title: 'sidenav.Home',
      icon: <PieChartOutlined />,
      iconActive: <PieChartOutlined />,
      role: 'dashboard:view',
      submenu: [],
    },
    {
      key: 'Statistics',
      path: `${ADMIN_PREFIX_PATH}/Statistics`,
      title: 'Statistics',
      icon: <LineChartOutlined />,
      iconActive: <LineChartOutlined />,
      role: 'dashboard:view',
      submenu: [],
    },
    {
      key: 'Forms',
      path: `${ADMIN_PREFIX_PATH}/Forms`,
      title: 'Forms',
      icon: <DatabaseOutlined />,
      iconActive: <DatabaseOutlined />,
      role: 'forms:view',
      submenu: [],
    },
    {
      key: 'Categories',
      path: `${ADMIN_PREFIX_PATH}/Categories`,
      title: 'Categories',
      icon: <ApartmentOutlined />,
      iconActive: <ApartmentOutlined />,
      role: 'category:create',
      submenu: [],
    },
    {
      key: 'Services',
      path: `${ADMIN_PREFIX_PATH}/Services`,
      title: 'homenav.Services',
      icon: <AppstoreOutlined />,
      iconActive: <AppstoreOutlined />,
      role: 'service:create',
      submenu: [],
    },
    {
      key: 'Requests',
      path: `${ADMIN_PREFIX_PATH}/Requests`,
      title: 'sidenav.Requests',
      icon: <FileDoneOutlined />,
      iconActive: <FileDoneOutlined />,
      role: 'requests:view',
      submenu: [
        {
          key: 'general',
          path: `${ADMIN_PREFIX_PATH}/Requests`,
          title: 'CAF e patronato',
        },
        {
          key: 'home-utilities',
          path: `${ADMIN_PREFIX_PATH}/Requests/home-utilities`,
          title: 'Utenze Casa',
        },
      ],
    },
    {
      key: 'Payments',
      path: `${ADMIN_PREFIX_PATH}/Payments`,
      title: 'sidenav.Payments',
      icon: <MoneyCollectOutlined />,
      iconActive: <MoneyCollectOutlined />,
      role: 'payments:view',
      submenu: [],
    },
    {
      key: 'FollowUp',
      path: `${ADMIN_PREFIX_PATH}/Follow-up-Inquiries`,
      title: 'Follow up Inquiries',
      icon: <MessageOutlined />,
      iconActive: <MessageOutlined />,
      role: 'ticket:view',
      submenu: [
        {
          key: 'Tickets',
          path: `${ADMIN_PREFIX_PATH}/Follow-up-Inquiries`,
          title: 'Tickets',
        },
        {
          key: 'Messages',
          path: `${ADMIN_PREFIX_PATH}/Messages`,
          title: 'Messages',
        },
      ],
    },
    {
      key: 'Blog',
      path: `${ADMIN_PREFIX_PATH}/Blog`,
      title: 'Blog',
      icon: <FileTextOutlined />,
      iconActive: <FileTextOutlined />,
      role: 'blog:create',
      submenu: [],
    },
    {
      key: 'users',
      path: `${ADMIN_PREFIX_PATH}/users`,
      title: 'sidenav.Users',
      icon: <TeamOutlined />,
      iconActive: <TeamOutlined />,
      submenu: [
        {
          key: 'Clients',
          path: `${ADMIN_PREFIX_PATH}/users/Clients`,
          title: 'sidenav.Clients',
          role: 'user:view',
        },
        {
          key: 'Resellers',
          path: `${ADMIN_PREFIX_PATH}/users/Resellers`,
          title: 'sidenav.Resellers',
          role: 'reseller:view',
        },
        {
          key: 'Admins',
          path: `${ADMIN_PREFIX_PATH}/users/Admins`,
          title: 'sidenav.Admins',
          role: 'admin:view',
        },
      ],
    },
    {
      key: 'Thank_you',
      path: `${ADMIN_PREFIX_PATH}/Thank-you`,
      title: 'Thank you',
      icon: <LikeOutlined />,
      iconActive: <LikeOutlined />,
      role: 'thank_you_page:view',
      submenu: [],
    },
    {
      key: 'login_history',
      path: `${ADMIN_PREFIX_PATH}/login-history`,
      title: 'Login History',
      icon: <HistoryOutlined />,
      iconActive: <HistoryOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'user-packages',
      path: `${ADMIN_PREFIX_PATH}/user-packages`,
      title: 'Pacchetti utente',
      icon: <ShopOutlined />,
      iconActive: <ShopOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'abbonamenti',
      path: `${ADMIN_PREFIX_PATH}/abbonamenti`,
      title: 'Abbonamenti',
      icon: <CreditCardOutlined />,
      iconActive: <CreditCardOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'packages',
      path: `${ADMIN_PREFIX_PATH}/packages`,
      title: 'Packages',
      icon: <ContainerOutlined />,
      iconActive: <ContainerOutlined />,
      role: ['admin:view', 'package-request:view'],
      submenu: [
        {
          key: 'packagesManage',
          path: `${ADMIN_PREFIX_PATH}/packages/packages-management`,
          title: 'Packages Management',
          role: 'admin:view',
        },
        {
          key: 'resellersManage',
          path: `${ADMIN_PREFIX_PATH}/packages/resellers-management`,
          title: 'Resellers Management',
          role: 'admin:view',
        },
        {
          key: 'packageRequests',
          path: `${ADMIN_PREFIX_PATH}/packages/packages-requests`,
          title: 'Package Requests',
          role: ['admin:view', 'package-request:view'],
        },
      ],
    },
    {
      key: 'administration',
      path: `${ADMIN_PREFIX_PATH}/Administration`,
      title: 'Administration',
      icon: <SettingOutlined />,
      iconActive: <SettingOutlined />,
      role: [ "admin:view",'admin:coupon-voucher' ],
      submenu: [
        {
          key: 'coupons',
          path: `${ADMIN_PREFIX_PATH}/Administration/coupons`,
          title: 'Codice Sconto',
          role: [ "admin:view",'admin:coupon-voucher' ],
        },
        {
          key: 'freeCoupons',
          path: `${ADMIN_PREFIX_PATH}/Administration/free-coupons`,
          title: 'Voucher',
          role: [ "admin:view",'admin:coupon-voucher' ],
        },
        {
          key: 'ActionsCount',
          path: `${ADMIN_PREFIX_PATH}/Administration/actions-count`,
          title: 'Actions Count',
          role: 'admin:view',
        },
        {
          key: 'Roles',
          path: `${ADMIN_PREFIX_PATH}/Administration/Roles`,
          title: 'Roles',
          role: 'admin:view',
        },
        {
          key: 'PermissionsAdmin',
          path: `${ADMIN_PREFIX_PATH}/Administration/Permissions`,
          title: 'Permissions',
          role: 'admin:view',
        },
        {
          key: 'zipCodes',
          path: `${ADMIN_PREFIX_PATH}/Administration/zip-codes`,
          title: 'Codici postali',
          role: 'admin:view',
        },
      ],
    },
    {
      key: 'error_logger',
      path: `${ADMIN_PREFIX_PATH}/error-logger`,
      title: 'Registratore di errori',
      icon: <CloseCircleOutlined />,
      iconActive: <CloseCircleOutlined />,
      role: 'admin:view',
      submenu: [],
    },
  ]
} else {
  navTree = [
    {
      key: 'Home',
      path: `${ADMIN_PREFIX_PATH}/Home`,
      title: 'sidenav.Home',
      icon: <PieChartOutlined />,
      iconActive: <PieChartOutlined />,
      role: 'dashboard:view',
      submenu: [],
    },
    {
      key: 'Statistics',
      path: `${ADMIN_PREFIX_PATH}/Statistics`,
      title: 'Statistics',
      icon: <LineChartOutlined />,
      iconActive: <LineChartOutlined />,
      role: 'dashboard:view',
      submenu: [],
    },
    {
      key: 'Forms',
      path: `${ADMIN_PREFIX_PATH}/Forms`,
      title: 'Forms',
      icon: <DatabaseOutlined />,
      iconActive: <DatabaseOutlined />,
      role: 'forms:view',
      submenu: [],
    },
    {
      key: 'Categories',
      path: `${ADMIN_PREFIX_PATH}/Categories`,
      title: 'Categories',
      icon: <ApartmentOutlined />,
      iconActive: <ApartmentOutlined />,
      role: 'category:create',
      submenu: [],
    },
    {
      key: 'Services',
      path: `${ADMIN_PREFIX_PATH}/Services`,
      title: 'homenav.Services',
      icon: <AppstoreOutlined />,
      iconActive: <AppstoreOutlined />,
      role: 'service:create',
      submenu: [],
    },
    {
      key: 'Requests',
      path: `${ADMIN_PREFIX_PATH}/Requests`,
      title: 'sidenav.Requests',
      icon: <FileDoneOutlined />,
      iconActive: <FileDoneOutlined />,
      role: 'requests:view',
      submenu: [
        {
          key: 'general',
          path: `${ADMIN_PREFIX_PATH}/Requests`,
          title: 'CAF e patronato',
        },
        {
          key: 'insurance',
          path: `${ADMIN_PREFIX_PATH}/Requests/insurance`,
          title: 'Assicurazione',
        },
        {
          key: 'home-utilities',
          path: `${ADMIN_PREFIX_PATH}/Requests/home-utilities`,
          title: 'Utenze Casa',
        },
        {
          key: 'translation',
          path: `${ADMIN_PREFIX_PATH}/Requests/translation`,
          title: 'Traduzione',
        },
      ],
    },
    {
      key: 'FEA',
      path: `${ADMIN_PREFIX_PATH}/FEA`,
      title: 'FEA',
      icon: <ScheduleOutlined />,
      iconActive: <ScheduleOutlined />,
      role: 'requests:view',
      submenu: [],
    },
    {
      key: 'Payments',
      path: `${ADMIN_PREFIX_PATH}/Payments`,
      title: 'sidenav.Payments',
      icon: <MoneyCollectOutlined />,
      iconActive: <MoneyCollectOutlined />,
      role: 'payments:view',
      submenu: [],
    },
    {
      key: 'FollowUp',
      path: `${ADMIN_PREFIX_PATH}/Follow-up-Inquiries`,
      title: 'Follow up Inquiries',
      icon: <MessageOutlined />,
      iconActive: <MessageOutlined />,
      role: 'ticket:view',
      submenu: [
        {
          key: 'Tickets',
          path: `${ADMIN_PREFIX_PATH}/Follow-up-Inquiries`,
          title: 'Tickets',
        },
        {
          key: 'Messages',
          path: `${ADMIN_PREFIX_PATH}/Messages`,
          title: 'Messages',
        },
      ],
    },
    {
      key: 'Blog',
      path: `${ADMIN_PREFIX_PATH}/Blog`,
      title: 'Blog',
      icon: <FileTextOutlined />,
      iconActive: <FileTextOutlined />,
      role: 'blog:create',
      submenu: [],
    },
    {
      key: 'users',
      path: `${ADMIN_PREFIX_PATH}/users`,
      title: 'sidenav.Users',
      icon: <TeamOutlined />,
      iconActive: <TeamOutlined />,
      submenu: [
        {
          key: 'Clients',
          path: `${ADMIN_PREFIX_PATH}/users/Clients`,
          title: 'sidenav.Clients',
          role: 'user:view',
        },
        {
          key: 'Resellers',
          path: `${ADMIN_PREFIX_PATH}/users/Resellers`,
          title: 'sidenav.Resellers',
          role: 'reseller:view',
        },
        {
          key: 'Admins',
          path: `${ADMIN_PREFIX_PATH}/users/Admins`,
          title: 'sidenav.Admins',
          role: 'admin:view',
        },
      ],
    },
    {
      key: 'Thank_you',
      path: `${ADMIN_PREFIX_PATH}/Thank-you`,
      title: 'Thank you',
      icon: <LikeOutlined />,
      iconActive: <LikeOutlined />,
      role: 'thank_you_page:view',
      submenu: [],
    },
    {
      key: 'login_history',
      path: `${ADMIN_PREFIX_PATH}/login-history`,
      title: 'Login History',
      icon: <HistoryOutlined />,
      iconActive: <HistoryOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'user-packages',
      path: `${ADMIN_PREFIX_PATH}/user-packages`,
      title: 'Pacchetti utente',
      icon: <ShopOutlined />,
      iconActive: <ShopOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'abbonamenti',
      path: `${ADMIN_PREFIX_PATH}/abbonamenti`,
      title: 'Abbonamenti',
      icon: <CreditCardOutlined />,
      iconActive: <CreditCardOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'packages',
      path: `${ADMIN_PREFIX_PATH}/packages`,
      title: 'Packages',
      icon: <ContainerOutlined />,
      iconActive: <ContainerOutlined />,
      role: ['admin:view', 'package-request:view'],
      submenu: [
        {
          key: 'packagesManage',
          path: `${ADMIN_PREFIX_PATH}/packages/packages-management`,
          title: 'Packages Management',
          role: 'admin:view',
        },
        {
          key: 'resellersManage',
          path: `${ADMIN_PREFIX_PATH}/packages/resellers-management`,
          title: 'Resellers Management',
          role: 'admin:view',
        },
        {
          key: 'packageRequests',
          path: `${ADMIN_PREFIX_PATH}/packages/packages-requests`,
          title: 'Package Requests',
          role: ['admin:view', 'package-request:view'],
        },
      ],
    },
       {
      key: 'administration',
      path: `${ADMIN_PREFIX_PATH}/Administration`,
      title: 'Administration',
      icon: <SettingOutlined />,
      iconActive: <SettingOutlined />,
      role: [ "admin:view",'admin:coupon-voucher' ],
      submenu: [
        {
          key: 'coupons',
          path: `${ADMIN_PREFIX_PATH}/Administration/coupons`,
          title: 'Codice Sconto',
          role: [ "admin:view",'admin:coupon-voucher' ],
        },
        {
          key: 'freeCoupons',
          path: `${ADMIN_PREFIX_PATH}/Administration/free-coupons`,
          title: 'Voucher',
          role: [ "admin:view",'admin:coupon-voucher' ],
        },
        {
          key: 'ActionsCount',
          path: `${ADMIN_PREFIX_PATH}/Administration/actions-count`,
          title: 'Actions Count',
          role: 'admin:view',
        },
        {
          key: 'Roles',
          path: `${ADMIN_PREFIX_PATH}/Administration/Roles`,
          title: 'Roles',
          role: 'admin:view',
        },
        {
          key: 'PermissionsAdmin',
          path: `${ADMIN_PREFIX_PATH}/Administration/Permissions`,
          title: 'Permissions',
          role: 'admin:view',
        },
        {
          key: 'zipCodes',
          path: `${ADMIN_PREFIX_PATH}/Administration/zip-codes`,
          title: 'Codici postali',
          role: 'admin:view',
        },
      ],
    }, 
    {
      key: 'EG_companies',
      path: `${ADMIN_PREFIX_PATH}/electricity-gas-companies`,
      title: 'electricity and gas companies',
      icon: <BankOutlined />,
      iconActive: <BankOutlined />,
      role: 'admin:view',
      submenu: [],
    },
    {
      key: 'error_logger',
      path: `${ADMIN_PREFIX_PATH}/error-logger`,
      title: 'Registratore di errori',
      icon: <CloseCircleOutlined />,
      iconActive: <CloseCircleOutlined />,
      role: 'admin:view',
      submenu: [],
    },
  ]
}

export default navTree
